import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of,Subject } from 'rxjs';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { environment } from '../../../environments/environment';
import { GetUtilizationPayload, GetUtilizationPayloadOperatingHours } from './stats.model';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class StatsService {
  private dateFrom = new Date();
  private dateTo = new Date();
  
  private _statsDateFilterSubscriber = new BehaviorSubject<{ dateFrom: any, dateTo: any }>(this.getDefaultFilterDate());
  public statsDateFilterSubscriber = this._statsDateFilterSubscriber.asObservable();

  private _statsQuickFilterSubscriber = new Subject<{ dateFrom: any, dateTo: any }>();
  public statsQuickFilterSubscriber = this._statsQuickFilterSubscriber.asObservable();
  constructor(
    private _httpClient: HttpClient,
    private _httpHeaderService: HttpHeadersService,
  ) { }

  getDefaultFilterDate(){
    this.dateFrom.setDate(this.dateFrom.getDate() - 90);
    this.dateTo.setDate(this.dateTo.getDate() - 1);
    let defaultDate = {
      dateFrom:this.dateFrom,
      dateTo:this.dateTo
    }
    return defaultDate;
  }

  public getDonutData(facilityId: string): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this._httpClient.get(environment.servicePath + '/statistics/get_product_mix?facilityId='+facilityId + '&v=' + Math.random(), { headers });
    return result as Observable<any>;
  }

  public getUtilization(facilityId: string, offset: number, facilityHoursStart?: number, facilityMinsStart?: number, facilityHoursEnd?: number, facilityMinsEnd?: number): Observable<any> {
    let data: GetUtilizationPayload | GetUtilizationPayloadOperatingHours;
    if (facilityHoursStart != undefined && facilityMinsStart != undefined && facilityHoursEnd != undefined && facilityMinsEnd != undefined) {
      data = {facilityId: facilityId, offset: offset, facilityHoursStart: facilityHoursStart, facilityMinsStart: facilityMinsStart, facilityHoursEnd: facilityHoursEnd, facilityMinsEnd: facilityMinsEnd};
    } else {
      data = {facilityId: facilityId, offset: offset};
    }
    

    let headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    return this._httpClient.post(environment.servicePath + '/statistics/report/utilization', data, { headers }).pipe(
      map((data: any) => {
      if(!Array.isArray(data.equipmentsUtilization)) {
        let tmp = data.equipmentsUtilization;
        data.equipmentsUtilization = [];
        data.equipmentsUtilization.push(tmp);
      }
      return data;
    }));
  }

  public getAverageByDay(facilityId: string, startDate: string, endDate: string, timeZone: string): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    return this._httpClient.get(environment.servicePath + '/statistics/report/dayofweek?facilityId=' + facilityId + '&startDate=' + startDate + '&endDate=' + endDate + '&timezone=' + timeZone +'&v=' + Math.random(), { headers }).pipe(
      map((data: any) => {
      if(data.reportMap == null) {
        data.reportMap = {entry: [], totalEquipmentCount: 0};
      }
      return data as Observable<any>;
    }));
  }

  public getAverageByTime(facilityId: string, startDate: string, endDate: string, timeZone: string): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this._httpClient.get(environment.servicePath + '/statistics/report/timeofday?facilityId=' + facilityId + '&startDate=' + startDate + '&endDate=' + endDate + '&timezone=' + timeZone +'&v=' + Math.random(), { headers });
    return result as Observable<any>;
  }

  public getAverageByEquipment(facilityId: string, startDate: string, endDate: string, timeZone: string): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this._httpClient.get(environment.servicePath + '/statistics/report/equipment?facilityId=' + facilityId + '&startDate=' + startDate + '&endDate=' + endDate + '&timezone=' + timeZone +'&v=' + Math.random(), { headers });
    return result as Observable<any>;
  }

  public getDetailsViewData(facilityId: string, startDate: string, endDate: string, timeZone: string): Observable<any> {
    const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
    const result = this._httpClient.get(environment.servicePath + '/statistics/report/detailed_view?facilityId=' + facilityId + '&startDate=' + startDate + '&endDate=' + endDate + '&timezone=' + timeZone +'&v=' + Math.random(), { headers });
    return result as Observable<any>;
  }

  public export(facilityId: string, startDate: string, endDate: string, timeZone: string, managerId: any): string {
    return environment.servicePath + '/statistics/export?facilityId=' + facilityId + '&startDate=' + startDate + '&endDate=' + endDate + '&timezoneOffset=' + timeZone + '&graphType=byequipment&managerId=' + btoa(managerId)
    ;
  }

  updateStatsDateFilter(obj: { dateFrom: any, dateTo: any }) {
    this._statsDateFilterSubscriber.next(obj);
  }

  updateStatsQuickFilter(obj:any) {
    this._statsQuickFilterSubscriber.next(obj);
  }
}
